import BaseViewController from "./base-view-controller";
import { formatPhone } from "../utils/prepare-submit";
import { getFlow } from "../api/flow";

class DoctorEditViewController extends BaseViewController {
  formState = {};

  prepareSubmit(values) {
    values = formatPhone(values, "phone_faxes.0.");
    values = formatPhone(values, "phone_faxes.1.");
    return { ...values, ...this.formState };
  }

  extractDoctorSpecialty() {
    const doctorSpeciality = this.appData.data.screens[
      this.appData.screenIndex
    ].fields
      .find(f => f.name === "provider_specialties.0.provider_taxonomy_cd")
      .options.find(
        o =>
          o.value ===
          this.appData.values["provider_specialties.0.provider_taxonomy_cd"]
      );
    return doctorSpeciality ? doctorSpeciality.text : "";
  }

  handleButtonClick(name, text, action) {
    const {
      values: { first_nm, last_nm }
    } = this.appData;
    if (["saveButton", "removeButton"].includes(name)) {
      getFlow({
        url: action?.value || this.screen.action.value,
        formState: this.prepareSubmit(this.appData.values)
      }).then(() => {
        const areaCode0 = this.appData.values["phone_faxes.0.area_code"];
        const areaCode1 = this.appData.values["phone_faxes.1.area_code"];
        const phoneNumber0 = this.appData.values["phone_faxes.0.phone_number"];
        const phoneNumber1 = this.appData.values["phone_faxes.1.phone_number"];
        this.formState = {
          doctor_name: `${first_nm} ${last_nm}`,
          doctor_specialty: this.extractDoctorSpecialty(),
          "phone_faxes.0.phone_number": `(${areaCode0}) ${phoneNumber0.substring(
            0,
            3
          )}-${phoneNumber0.substring(3)}`,
          "phone_faxes.1.phone_number": `(${areaCode1}) ${phoneNumber1.substring(
            0,
            3
          )}-${phoneNumber1.substring(3)}`,
          makePrimaryCheckbox: this.appData.values.pcp_flg
        };
        const replaceHistory = name === "saveButton" ? 2 : 3;
        const initialScreen = name === "saveButton" ? "DoctorDetail" : null;
        super.handleButtonClick(
          name,
          {},
          {
            type: "url",
            value: "/screens/doctors"
          },
          replaceHistory,
          initialScreen
        );
      });
    }
  }
}

export default DoctorEditViewController;
